import { Button } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { StyledFlex } from './SideBarMenuSaveSection.styled'
import { useTranslation } from 'react-i18next'

export const SidebarMenuSaveSection = ({ saveCase }) => {
  const { t } = useTranslation()
  return (
    <>
      <StyledFlex full center column position="absolute" bottom="0">
        <Flex full center column>
          <Flex
            justify="flex-end"
            align="center"
            borderTop="1px solid"
            borderColor="gray4"
            width="100%"
            background="fill"
          ></Flex>
        </Flex>
        <Flex full center padding="8px 8px" gap="8px" column>
          <Flex
            justify="flex-end"
            align="center"
            padding="16px 24px"
            gap="8px"
            width="100%"
          >
            <Button
              data-testid="case-details-save-button"
              primary
              onClick={() => {
                saveCase()
              }}
            >
              {t('editor.saveButton')}
            </Button>
          </Flex>
        </Flex>
      </StyledFlex>
    </>
  )
}

export default SidebarMenuSaveSection
